import utils from './axios-utils';
import { format } from 'date-fns';
const JSONbigNative = require('json-bigint')({ useNativeBigInt: true });
const JSONbig = require('json-bigint')({ useNativeBigInt: false });;

const AUDIT_TRAIL_TS = ["createdTs","updatedTs"];
const DATE_PATTERN = "yyyy-MM-dd";

const setContentTypeIfUnset = (headers, value) => {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

const parseJsonWithBigInt = (data) => {
  if (typeof data === 'string') {
    try {
      return JSONbigNative.parse(data);
    } catch (e) {
      try {
        const bigObj = JSONbig.parse(data);

        const convertBigNumberToBigInt = (obj) => {
          if (typeof obj === 'object' && obj !== null) {
            for (const key in obj) {
              if (typeof obj[key] === 'object' && obj[key] !== null) {
                if (obj[key].constructor && (Object.prototype.hasOwnProperty.call(obj[key].constructor, "isBigNumber") || Object.prototype.hasOwnProperty.call(obj[key].constructor, "BigNumber"))) {
                  const numStr = obj[key].toString();
                  
                  // 소수점이 있는 경우에는 BigInt 변환 X
                  if (numStr.includes(".")) {
                    obj[key] = parseFloat(numStr); // 일반 Number로 변환
                  } else {
                    obj[key] = (typeof BigInt !== "undefined")
                      ? JSONbigNative.parse(numStr)  // BigInt 변환 (정수만)
                      : numStr;         // BigInt 미지원 환경에서는 String 처리
                  }
                } else {
                  convertBigNumberToBigInt(obj[key]); // 재귀 호출
                }
              }
            }
          }
          return obj;
        };

        return convertBigNumberToBigInt(bigObj);
      } catch (el) {
        /* Ignore */
        // Added this Ignore as it's the same in the Axios
      }
    } 
  }

  return data;
}

const transformResponse = [(data) => {
  const transformData = parseJsonWithBigInt(data);

  return transformData;
}];

const dateSerializer = (data) => {
  const dateValidation = (attrName, attrValue) => {
    return attrValue instanceof Date && !AUDIT_TRAIL_TS.includes(attrName);
  }

  for (const item in data) {
    if (Object.prototype.hasOwnProperty.call(data, item)) {
      if (dateValidation(item, data[item])) {
        data[item] = format(data[item], DATE_PATTERN);
      }

      if (typeof data[item] !== "object") {
        continue;
      }

      for (const e in data[item]) {
        if (Object.prototype.hasOwnProperty.call(data[item], e)) {
          if (dateValidation(data[item], data[item][e])) {
            data[item][e] = format(data[item][e], DATE_PATTERN);
          }
        }
      }
    }
  }
}

const transformRequest = [(data, headers) => {
  utils.normalizeHeaderName(headers, 'Accept');
  utils.normalizeHeaderName(headers, 'Content-Type');
  
  dateSerializer(data);

  if (utils.isFormData(data) ||  
    utils.isArrayBuffer(data) ||
    utils.isBuffer(data) ||
    utils.isStream(data) ||
    utils.isFile(data) ||
    utils.isBlob(data)
  ) {
    return data;
  }

  if (utils.isArrayBufferView(data)) {
    return data.buffer;
  }

  if (utils.isURLSearchParams(data)) {
    setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
    return data.toString();
  }

  if (utils.isObject(data)) {
    setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
    return JSONbigNative.stringify(data);
  }

  return data;
}];

const jsonbigStringfy = (data) => {
  return JSONbigNative.stringify(data);
};

const jsonbigParse = (data) => {
  return JSONbigNative.parse(data);
};

const axiosUtils = {
  transformResponse,
  transformRequest,
  jsonbigStringfy,
  jsonbigParse,
  parseJsonWithBigInt
}

export default axiosUtils;
